var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "window" }, [
    _c("div", { attrs: { id: "card_block" } }, [
      _vm.item.NAME
        ? _c("div", { staticClass: "card-add-product" }, [
            _c(
              "div",
              { staticClass: "img-left" },
              [
                _vm._l(_vm.item.OFFERS, function (OFFER) {
                  return _vm.item.OFFERS
                    ? _c("div", { staticClass: "offer" }, [
                        OFFER.VALUE == "1233"
                          ? _c("div", {
                              staticClass: "item-promo-popular-peop",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        OFFER.VALUE == "1231"
                          ? _c("div", { staticClass: "item-promo-akcii" })
                          : _vm._e(),
                        _vm._v(" "),
                        OFFER.VALUE == "1230"
                          ? _c("div", { staticClass: "item-promo-new" })
                          : _vm._e(),
                        _vm._v(" "),
                        OFFER.VALUE == "1232"
                          ? _c("div", { staticClass: "item-promo-xit" })
                          : _vm._e(),
                        _vm._v(" "),
                        OFFER.VALUE == "1234"
                          ? _c("div", { staticClass: "item-promo-rent-i" })
                          : _vm._e(),
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.item.GALLERY.LARGE
                  ? _c("img", {
                      attrs: { src: _vm.item.GALLERY.LARGE[0].src, alt: "" },
                    })
                  : _c("img", {
                      attrs: { src: _vm.item.GALLERY[0].src, alt: "" },
                    }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "data-right" }, [
              _c(
                "div",
                { staticClass: "stars" },
                [
                  _vm._l(5, function (star) {
                    return _c("div", {
                      staticClass: "star",
                      class: { active: _vm.getRating(star, _vm.item) },
                    })
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "count-feed" }, [
                    _vm._v("(" + _vm._s(_vm.getCountFeed(_vm.item)) + ")"),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "shop-name-container" }, [
                _c(
                  "a",
                  {
                    staticClass: "shop-name",
                    attrs: { href: _vm.item.DETAIL_PAGE_URL },
                  },
                  [
                    _vm._v(
                      "\n                                            " +
                        _vm._s(_vm.item.NAME) +
                        "\n                                        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pos-pr-rel" }, [
                _c("div", {
                  staticClass: "price-list",
                  domProps: { innerHTML: _vm._s(_vm.item.FORMAT_PRICE) },
                }),
                _vm._v(" "),
                _vm.item.PRICE_OLD > 0
                  ? _c("div", { staticClass: "old-price-block" }, [
                      _c("del", {
                        staticClass: "dis-pr-f",
                        domProps: {
                          innerHTML: _vm._s(_vm.item.FORMAT_PRICE_OLD),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "dis-pr hide" }, [
                        _vm._v("-" + _vm._s(_vm.item.DISCOUNT_PR) + "%"),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttons" }, [
              _c(
                "a",
                {
                  staticClass: "feed-back-call-b next-buy",
                  attrs: { href: "/" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.closeFancy()
                    },
                  },
                },
                [_vm._v("Продолжить покупки")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "feed-back-call-b go-basket",
                  attrs: { href: "/personal/cart/" },
                },
                [_vm._v("В корзину")]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }